// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__Z9hz4","large":"styles_large__2BjXz"};